import { createGenericDispatcher } from '../../action/action-dispatcher-factory';
import { addNotificationAction } from '../../action/notifications/notifications';

import * as Api from '../../api/api';

export const reassignEmployeeGroups = ({
  orgId,
  groupReassignments,
  explicitEmployeeAssignments,
  groupsToFilter,
}: { orgId: number } & ReassignEmployeeGroupsRequest) =>
  createGenericDispatcher({
    name: 'REASSIGN_EMPLOYEE_GROUPS',
    loadFunction: () =>
      Api.post('/employee-groups/reassign-to-orgs', {
        body: JSON.stringify({
          orgId,
          groupReassignments,
          explicitEmployeeAssignments,
          groupsToFilter,
        }),
      }),
    onSuccess: (dispatch: Function) => {
      dispatch(
        addNotificationAction({
          key: 'reassign-employee-groups',
          message: 'Groups are being reassigned. Please check back later.',
        }),
      );
    },
    args: { orgId, groupReassignments, explicitEmployeeAssignments },
  });
